
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const comparisonTable = [
  {
    feature: "Assessment Approach",
    traditional: "Generic questionnaires",
    aimaa: "Industry-specific, context-aware evaluation"
  },
  {
    feature: "Benchmarking",
    traditional: "Static reports and outdated data",
    aimaa: "Real-time, AI-powered industry benchmarks"
  },
  {
    feature: "Recommendations",
    traditional: "Generic best practices",
    aimaa: "Personalized, actionable roadmaps"
  },
  {
    feature: "Industry Context",
    traditional: "One-size-fits-all approach",
    aimaa: "Tailored to specific industry needs"
  },
  {
    feature: "Update Frequency",
    traditional: "Annual or bi-annual",
    aimaa: "Continuous, real-time updates"
  },
  {
    feature: "Support Model",
    traditional: "Basic report delivery",
    aimaa: "Ongoing guidance and tracking"
  }
];

export const ComparisonTable = () => {
  const navigate = useNavigate();

  const handleStartAssessment = () => {
    // Navigate to the assessment page
    navigate("/assessment");
  };

  return (
    <section className="animate-fade-in" style={{ animationDelay: "450ms" }}>
      <h2 className="text-xl sm:text-2xl font-semibold text-[#0f2d69] mb-4 sm:mb-6">
        How AIMAA Compares to Other AI Maturity Models
      </h2>
      <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-8">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[#0f2d69] text-white">
                <th className="px-4 sm:px-6 py-4 text-left text-sm sm:text-base font-medium">Feature</th>
                <th className="px-4 sm:px-6 py-4 text-left text-sm sm:text-base font-medium">Traditional Models</th>
                <th className="px-4 sm:px-6 py-4 text-left text-sm sm:text-base font-medium">AIMAA</th>
              </tr>
            </thead>
            <tbody>
              {comparisonTable.map((row, index) => (
                <tr 
                  key={index} 
                  className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                >
                  <td className="px-4 sm:px-6 py-4 font-medium text-[#0f2d69] text-sm sm:text-base">{row.feature}</td>
                  <td className="px-4 sm:px-6 py-4 text-gray-600 text-sm sm:text-base">{row.traditional}</td>
                  <td className="px-4 sm:px-6 py-4 text-gray-600 text-sm sm:text-base">{row.aimaa}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="text-center">
        <Button 
          onClick={handleStartAssessment}
          className="w-full sm:w-auto h-12 px-6 sm:px-8 text-base sm:text-lg bg-[#0f2d69] hover:bg-[#0f2d69]/90 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Start Your Assessment
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </div>
    </section>
  );
};
